import { render, staticRenderFns } from "./detail.view.vue?vue&type=template&id=049e4b57&"
import script from "./detail.view.ts?vue&type=script&lang=js&"
export * from "./detail.view.ts?vue&type=script&lang=js&"
import style0 from "./detail.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports